import React from "react";
import QuizType2 from "./QuizType2";
import QuizType3 from "./QuizType3";
import QuizType4 from "./QuizType4";
import doctor from "../../../assets/images/characters/doctor.png";
import ButtonRepeat from "../../../assets/images/others/ButtonRepeat.png";
import s from "./style.module.css";

const Quiz = ({
  item,
  index,
  Repeat,
  handleGetAnswer,
  speakerImg,
  handleRepeat,
}) => {
  const handleClickSpeaker = (e) => {
    e.stopPropagation();
  };
  const renderQuizType = (type) => {
    switch (type) {
      case 2:
        return (
          <QuizType2
            item={item}
            index={index}
            // answer={answerType1}
            handleGetAnswer={handleGetAnswer}
            handleClickSpeaker={handleClickSpeaker}
            speakerImg={speakerImg}
          />
        );
      case 3:
        return (
          <QuizType3
            item={item}
            index={index}
            // answer={answerType3}
            handleGetAnswer={handleGetAnswer}
            speakerImg={speakerImg}
          />
        );
      case 4:
        return (
          <QuizType4
            item={item}
            index={index}
            // answer={answerType3}
            handleGetAnswer={handleGetAnswer}
            speakerImg={speakerImg}
          />
        );
      case 5:
        return (
          <QuizType2
            type5
            item={item}
            index={index}
            // answer={answerType3}
            handleGetAnswer={handleGetAnswer}
            speakerImg={speakerImg}
          />
        );
      default:
        return (
          <QuizType2
            item={item}
            index={index}
            // answer={answerType1}
            handleGetAnswer={handleGetAnswer}
            handleClickSpeaker={handleClickSpeaker}
            speakerImg={speakerImg}
          />
        );
    }
  };
  return (
    <div className={s.QuizContainer}>
      {Repeat ? (
        renderQuizType(item.quizType)
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div>
            <img className={s.CharacterWrapper} src={doctor} alt="character" />
          </div>
          <div style={{ flex: 1 }}>
            <p
              style={{
                fontSize: "2vmax",
                color: "#000000",
                fontWeight: "bold",
              }}
            >
              น้าหมอคิดว่าข้อนี้ไม่ถูกต้อง น้องๆลองตอบใหม่อีกครั้งนะครับ
            </p>

            <img
              className={s.ButtonRepeat}
              src={ButtonRepeat}
              alt=""
              onClick={() => handleRepeat(true)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Quiz;
